import axios from 'axios'
import store from '../vuex'
import { apiUrl } from '../../config/base'
import { uuid } from '../../mixins/uuid'

/**
 * Create Axios
 */
const http = axios.create({
  baseURL: apiUrl
})

/**
 * Set static headers
 */
http.defaults.headers.common = {
  'Accept': 'application/json'
}

/**
 * Add dynamic headers
 */
http.interceptors.request.use(config => {
  config.withCredentials = true
  config.headers['Path'] = _.get(store.state, 'path')
  config.headers['Device'] = _.get(store.state, 'deviceId')
  config.headers['Company'] = _.get(store.state, 'user.company.id', 0)
  config.headers['Platform'] = 'platform'
  config.headers['X-CSRF-TOKEN'] = _.get(store.state, 'csrfToken')

  store.commit('assignValue', {
    ajaxing: true
  })

  return config
}, error => {
  store.commit('assignValue', {
    ajaxing: false
  })

  return Promise.reject(error);
})

/**
 * Handle all error messages.
 */
http.interceptors.response.use(response => {
  store.commit('assignValue', {
    ajaxing: false
  })

  const id = uuid()
  const message = _.get(response.data, 'message')
  if (message) {
    store.commit('pushSnackbar', {
      id: id,
      type: 'success',
      message: message,
      timeout: setTimeout(() => {
        store.commit('removeSnackbar', id)
      }, 2000)
    })
  }

  return response
}, error => {
  store.commit('assignValue', {
    ajaxing: false
  })

  const id = uuid()
  const path = new URL(error.response.config.url)
  switch (error.response.status) {
    case 401:
      store.commit('assignValue', {
        logoutTag: store.state.logoutTag + 1
      })
      break
    case 403:
      store.commit('pushSnackbar', {
        id: id,
        type: 'error',
        message: _.get(error.response.data, 'message'),
        timeout: setTimeout(() => {
          store.commit('removeSnackbar', id)
        }, 4000)
      })
      break
    case 404:
      store.commit('pushSnackbar', {
        id: id,
        type: 'error',
        message: '请求的路径不存在',
        desc: path.pathname,
        timeout: setTimeout(() => {
          store.commit('removeSnackbar', id)
        }, 4000)
      })
      break
    case 422:
      _.forEach(_.get(error.response.data, 'errors'), error => {
        store.commit('pushSnackbar', {
          id: id,
          type: 'error',
          message: error,
          timeout: setTimeout(() => {
            store.commit('removeSnackbar', id)
          }, 4000)
        })
      })
      break
    case 500:
      store.commit('pushSnackbar', {
        id: id,
        type: 'error',
        message: '服务器内部错误',
        desc: path.pathname
      })
      break
  }
  return Promise.reject(error)
})

export default function install (Vue) {
  Object.defineProperty(Vue.prototype, '$http', { value: http })
}
